export default "<div class=\"blue\">\n    <div class=\"white\">\n        <app-organisation-list></app-organisation-list>\n    </div>\n</div>";